import { Card, PageHeader } from '../components/ui';

export function Member() {
    return (
        <div className="max-w-md mx-auto">
            <PageHeader title="สมัครสมาชิก" subtitle="สแกน QR Code เพื่อเพิ่มเพื่อน LINE" />

            <Card padding="lg">
                {/* QR Code */}
                <div className="bg-neutral-50 rounded-xl p-8 mb-6">
                    <div className="aspect-square bg-white rounded-xl border-2 border-dashed border-neutral-200 
                          flex items-center justify-center">
                        <div className="text-center">
                            <div className="text-8xl mb-4">📱</div>
                            <p className="font-medium text-neutral-700">QR Code</p>
                            <p className="text-xs text-neutral-500 mt-1">LINE Official Account</p>
                        </div>
                    </div>
                </div>

                {/* Steps */}
                <div className="space-y-4">
                    <Step number={1} title="เปิด LINE" description="เปิดแอป LINE บนมือถือ" />
                    <Step number={2} title="สแกน QR Code" description="ใช้ฟีเจอร์สแกน QR" />
                    <Step number={3} title="เพิ่มเพื่อน" description="กดปุ่มเพิ่มเพื่อน" />
                </div>
            </Card>

            {/* Note */}
            <div className="mt-6 p-4 bg-neutral-100 rounded-xl">
                <p className="text-xs text-neutral-600">
                    <span className="font-medium">หมายเหตุ:</span> ผู้ดูแลระบบสามารถเปลี่ยน QR Code ได้ในหน้า Admin
                </p>
            </div>
        </div>
    );
}

function Step({ number, title, description }: { number: number; title: string; description: string }) {
    return (
        <div className="flex items-start gap-4">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-sm font-bold">{number}</span>
            </div>
            <div>
                <p className="font-medium text-neutral-900">{title}</p>
                <p className="text-sm text-neutral-500">{description}</p>
            </div>
        </div>
    );
}
